import { api } from '@/lib/api';
import { UserData } from '@/types';

export class UserService {
  static async getAll(): Promise<UserData[]> {
    const response = await api.get<UserData[]>('/users');
    return response.data;
  }

  static async getById(id: string): Promise<UserData> {
    const response = await api.get<UserData>(`/users/${id}`);
    return response.data;
  }

  static async update(id: string, updates: { user: Partial<UserData> }): Promise<UserData> {
    const response = await api.put<UserData>(`/users/${id}`, updates);
    return response.data;
  }

  static async delete(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  }
}
